var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EE741F",
    d: "M11.85 1C17.842 1 22.7 5.858 22.7 11.85S17.842 22.7 11.85 22.7 1 17.842 1 11.85 5.858 1 11.85 1zm0 1.7c-5.053 0-9.15 4.097-9.15 9.15S6.797 21 11.85 21 21 16.903 21 11.85 16.903 2.7 11.85 2.7zm-.526 2.907c.433 0 .791.324.843.744l.007.106v5.474l3.53 1.766c.388.194.563.644.422 1.042l-.042.098c-.194.388-.643.563-1.042.422l-.098-.042-4-2c-.252-.126-.423-.367-.462-.64l-.008-.12v-6c0-.47.38-.85.85-.85z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsClock);
export default __webpack_public_path__ + "static/media/icons_clock.86143cacdc2851ab6c789fac0fda0a79.svg";
export { ForwardRef as ReactComponent };